import {
  Dialog,
  DialogBody,
  DialogButton,
  DialogButtons,
  DialogCloseX,
  DialogContent,
  DialogHeading,
} from "@tandemdiabetes/sugarmate-react-components"
import type { MouseEventHandler } from "react"
import { usePolyglot } from "src/contexts"

interface Props {
  open: boolean;
  setOpen: (o: boolean) => void;
  inviteFollower: MouseEventHandler<HTMLButtonElement>;
  email: string;
}

const polyglotPrefix =
  "pages.data_sharing.invite_a_follower.invite_dialog."

/*
 * renders a dialog asking the user to confirm that invite a follower
 */
export function SendInvitationDialog(props: Props) {
  const {
    setOpen, open: isOpen, inviteFollower, email,
  } = props

  const polyglot = usePolyglot()

  return (
    <Dialog
      open={isOpen}
      onOpenChange={setOpen}
    >
      <DialogContent id="send-invitation-dialog">
        <DialogHeading>
          {polyglot.t(`${polyglotPrefix}header`)}
          <DialogCloseX />
        </DialogHeading>
        <DialogBody>
          <div>
            {polyglot.t(
              `${polyglotPrefix}description_one`,
              { email },
            )}
          </div>
          <div>
            {polyglot.t(`${polyglotPrefix}description_two`)}
          </div>
        </DialogBody>
        <DialogButtons>
          <DialogButton
            stylePreset="secondary"
            id="cancel-invite-follower"
          >
            {polyglot.t(`${polyglotPrefix}cancel_cta`)}
          </DialogButton>
          <DialogButton
            stylePreset="primary"
            id="confirm-invite-follower-btn"
            onClick={inviteFollower}
          >
            {polyglot.t(`${polyglotPrefix}confirm_cta`)}
          </DialogButton>
        </DialogButtons>
      </DialogContent>
    </Dialog>
  )
}
